<script>
  import { DateTime } from "luxon";
  import * as yup from "yup";
  import { createEventDispatcher, onMount } from "svelte";
  import { account, appSession, appConstants } from "../stores/app.js";
  import MyModal from "../components/MyModal.svelte";
  import { navigate } from "svelte-routing";

  let badCredentials = false;
  let errorMessage = '';
  let busy = false;
  let passwordRecoverMode = false;
  const dispatch = createEventDispatcher();

  let myModal;

  let form = {
    dirty: false,
    valid: true,
    submitted: false,

    data: {
      email: "",
      password: "",
    },

    schema: yup.object().shape({
      email: yup.string().lowercase().email({ message: "Invalid" }).required({ message: "Required" }),
      password: yup.string().required({ message: "Required" }),
    }),
    errors: null,
  };

  let recoverForm = {
    dirty: false,
    valid: true,
    submitted: false,

    data: {
      email: "",
    },

    schema: yup.object().shape({
      email: yup.string().lowercase().email({ message: "Invalid" }).required({ message: "Required" }),
    }),
    errors: null,
  };

  onMount(() => {
    M.updateTextFields();
  });

  function ValidateForm() {
    return new Promise(function (resolve, reject) {
      form.schema
        .validate(form.data, { abortEarly: false })
        .then((values) => {
          form.valid = true;
          form.errors = {};

          resolve(true);
        })
        .catch((validationErrors) => {
          form.valid = false;
          form.errors = {};

          for (let i = 0; i < validationErrors.inner.length; i++) {
            let error = validationErrors.inner[i];
            form.errors[error.path] = {
              type: error.type,
              message: typeof error.errors[0] == "object" ? error.errors[0].message : error.errors[0],
            };
          }
        });
    });
  }

  // resolve session token
  function GetToken() {
    return new Promise((resolve, reject) => {
      let credentials = {
        username: form.data.email,
        password: form.data.password,
      };

      const xhr = new XMLHttpRequest();
      xhr.open("POST", $appConstants.apiURLBase + "token/pilot/webapp");
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.send(JSON.stringify(credentials));

      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve(response.token);
        } catch (e) {
          reject(e);
        }
      };

      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }

  // resolves account associated with session token
  function GetAccount(token, pilotId) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", $appConstants.apiURLBase + "pilots/" + pilotId);

      xhr.setRequestHeader("Authorization", "Bearer " + token);
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.send("");

      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          let subscriptionRequired = !response.data.stripe_customerid ? true : false;

          let subscriptionExpired = false;
          if (!response.data.stripe_subscription_status || response.data.stripe_subscription_status == "inactive")
            subscriptionExpired = true;
          else {
            let subscriptionExpiresTime = DateTime.fromISO(response.data.stripe_subscription_end.replace(" ", "T"), {
              zone: "UTC",
            });
            subscriptionExpiresTime = subscriptionExpiresTime.plus({ hours: 48 });
            let nowUTC = DateTime.utc();
            if (subscriptionExpiresTime < nowUTC) subscriptionExpired = true;
          }

          resolve({
            name: response.data.lastname.toUpperCase() + ", " + response.data.firstname,
            email: response.data.email,
            subscriptionRequired: subscriptionRequired,
            subscriptionExpired: subscriptionExpired,
          });
        } catch (e) {
          reject(e);
        }
      };

      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }

  async function FieldChanged(field) {
    form.dirty = true;
  }

  // attempt user login dispatching login event if successfull
  async function Login() {
    form.submitted = true;

    try {
      await ValidateForm(form);
      busy = true;
      let token = await GetToken();
      let pilotId = parseInt(token.split("-")[3]);
      let account = await GetAccount(token, pilotId);
      busy = badCredentials = false;

      dispatch("login", {
        authorisationToken: token,
        pilotId: pilotId,
        name: account.name,
        email: account.email,
        subscriptionRequired: account.subscriptionRequired,
        subscriptionExpired: account.subscriptionExpired,
      });
    } catch (error) {
      busy = false;
      badCredentials = false;

      switch (error) {
        case "BadRole":
        case "BadRealm":
          appSession.set({ authorisationToken: null, pilotId: null });
          break;
        case "NetworkError":
          myModal.showAlert(
            "Network error",
            "A network error occurred.<p> Check network connection and try again.</p>"
          );
          break;
        case "badcredentials":
        case "BadCredentials":
          badCredentials = true;
          errorMessage = "Invalid username or password";
          break;
         case "OperatorExpired":
          badCredentials = true;
          errorMessage = "Operator account expired or disabled";
          break;
        default:
          badCredentials = true;
          errorMessage = "Internal error: "+error;
          break;
      }
    }
  }

  function handleKeydown(event) {
    if (event.key == "Enter") Login();
  }
</script>

<style>
  .helper-text {
    margin-bottom: 30px;
  }

  .banner {
    background: url(../assets/login-banner.jpg);
    background-size: cover;
    background-position: center;
    height: 20vh;
    color: #fff;
    font-size: 32pt;
    font-weight: 600;
    letter-spacing: 20px;
    display: flex;
    align-items: center;
  }

  @media (min-width: 768px) {
    .banner {
      height: 40vh;
      font-size: 56pt;
    }
  }
</style>

<div class="banner">
  <div style="opacity: 0.6; text-align: center; width: 100%; text-shadow: #000 1px 1px 4px;">PILOTS</div>
</div>

<div class="container">
  <div class="row">
    <div class="col s12 m8 offset-m2 l6 offset-l3 xl4 offset-xl4">
      <img
        src="assets/logo.png"
        style="display: block; max-width: 100%; height: auto; margin: 40px auto 40px auto;"
        alt="" />

      <div class="input-field">
        <input type="email" bind:value={form.data.email} on:change={() => FieldChanged('email')} />
        <label>Email</label>
        {#if form.errors && form.errors.email}
          <div class="helper-text red-text">{form.errors.email.message}</div>
        {/if}
      </div>

      <div class="input-field">
        <input type="password" bind:value={form.data.password} on:change={() => FieldChanged('password')} />
        <label>Password</label>
        {#if form.errors && form.errors.password}
          <div class="helper-text red-text">{form.errors.password.message}</div>
        {/if}
      </div>

      <div style="display: flex; justify-content: space-between; align-items: center;">
        <a
          href="#!"
          on:click={() => {
            navigate('passwordrecover');
          }}>
          Forgot password
        </a>

        <button
          class="btn wave-effect blue-grey"
          on:click={() => {
            Login();
          }}
          disabled={busy}>
          Sign-in
        </button>
      </div>

      {#if badCredentials}
        <div
          style="text-align: center; padding-top: 20px; color: red; text-transform: uppercase; font-size: 0.8em; clear:
          both;">
          {errorMessage}
        </div>
      {/if}

      <div style="margin-top: 60px; text-align: center; font-size: 0.7em; color: #ccc;">
        <p>Copyright &copy; 2022 Jumphub LLC <br /> Build {$appConstants.version}</p>
      </div>

      {#if busy}
        <div style="display: flex; justify-content: center; align-items: center; height: 50px; width: 100%;">
          <div class="preloader-wrapper small active">
            <div class="spinner-layer spinner-green-only">
              <div class="circle-clipper left">
                <div class="circle" />
              </div>
              <div class="gap-patch">
                <div class="circle" />
              </div>
              <div class="circle-clipper right">
                <div class="circle" />
              </div>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
</div>

<MyModal bind:this={myModal} />

<svelte:window on:keydown={handleKeydown} />
